import { useDispatch, useSelector } from 'react-redux';

// Export pre-typed hooks for use throughout the app
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
